<script>
import { HorizontalBar, mixins } from "vue-chartjs";

const { reactiveProp } = mixins;

export default {
  extends: HorizontalBar,
  mixins: [reactiveProp],
  props: ["chartdata", "options"],
  mounted() {
    // http://www.chartjs.org/docs/latest/#creating-a-chart
    // this.chartData is created in the mixin
    // to pass in options, create a local options object
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    options(val) {
      this.renderChart(this.chartData, this.options);
    },
  },
};
</script>
